






















































import Tooltip from "./Tooltip.vue";
import { NavigationMixin } from "@/mixins/navigate";
import Vue from "vue";

export default Vue.extend({
  mixins: [NavigationMixin],

  components: { Tooltip },

  props: {
    type: {
      type: String,
      default: "button",
    },

    outlined: {
      type:Boolean,
      default: true
    },

    icon: {
      type: String,
      default: "fa-plus",
    },

    tooltip: {
      type: String,
      default: "",
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    color: {
      type: String,
      default: "primary",
    },

    btnStyles: {
      type: String,
      default: "",
    },

    btnClasses: {
      type: String,
      default: "",
    },

    top: {
      type: Boolean,
      default: false,
    },

    dropdown: {
      type: Boolean,
      default: false,
    },

    navTo: {
      type: String,
      default: "",
    },

    text: {
      type: String,
      default: "",
    },
  },

  methods: {
    clickHandler(event: MouseEvent) {
      if (this.navTo) {
        this.navigate(this.navTo, event);
        return;
      }
      this.$emit("click");
    },
  },
});
